import React from "react";
import { Rating } from "@mui/material";
import './style/shopinforating.css'
import { FaTruck } from "react-icons/fa";
import { GiThermometerScale } from "react-icons/gi";
import { SlCalender } from "react-icons/sl";
import { HiOutlineShoppingBag } from "react-icons/hi2";
import { GiAbbotMeeple } from "react-icons/gi";
import { Tooltip } from 'react-tooltip'
import { IoColorWandOutline } from "react-icons/io5";
import { FaTags } from "react-icons/fa";

export const ShopInfoRating = ({ product }) => {

  return (
    <div>
      
      <div>
        <div>
          <p className="mb-2 mt-2 text-slate-500  text-3xl font-medium">{product[0].prdname}</p>
          <p className="my-5 tracking-wider text-gray-600 ">{product[0].dec}</p>
          <p className="mb-3 tracking-wider text-gray-800">
            <span className="my-2 font-semibold">Price : Price on Request</span>
            <p className="text-sm tracking-wider " >*The price of this item will vary based on grammage and the gold rate on that particular day call us </p>
            <a href="tel:+32483001517" className="underline">+32-483-0015-17</a>
          </p>
        </div>
        <div className="flex mb-3 justify-center align-center rating ">
          <div>
            {product[0].rating ? (
              <span>

                <Rating
                  name="read-only"
                  value={product[0].rating}
                  size='small'
                  className="mt-1"
                />
             
              </span>
            ) : (
              <span></span>
            )}

          </div>
          <p className=" ms-2 text-md text-slate-500">reviews</p>
        </div>
      </div>
      <div className="my-5">
        <p className="flex mr-2 "><span className="text-lg"><FaTruck /></span><span className="uppercase text-xs font-medium ms-2 tracking-wider"> DELIVERY & RETURN</span></p>
        <p className="flex mr-2 my-3"><span className="text-lg"><GiThermometerScale /></span><span className="uppercase text-xs font-medium ms-2 tracking-wider"> size</span></p>
        <p className="flex mr-2"><span className="text-lg"><SlCalender /></span><span className="uppercase text-xs font-medium ms-2 tracking-wider"> ESTIMATED DELIVERY : 1week</span></p>
      </div>
      <div>
        <p className="flex border p-3 border-amber-200 bg-amber-50"><span><HiOutlineShoppingBag className="text-xl me-2 text-amber-600" /></span> <span className="text-sm text-gray-800 tracking-wider">33 people have this in their carts right now. It's running out!</span></p>
      </div>
      <div className="my-5">

        <div>
          <div>
            <p className="my-3 flex">
              <Tooltip id="my-tooltip" />
              <p data-tooltip-id="my-tooltip" data-tooltip-content="TAGS" className="uppercase text-xl font-semibold tracking-wide ms-2 text-gray-600 ">
                <FaTags />
              </p>
              <span className="text-black text-sm tracking-wider  font-semibold"> : Bestseller, Trend</span>
            </p>
            <p className="my-3 flex">
              <Tooltip id="my-tooltip" />
              <p data-tooltip-id="my-tooltip" data-tooltip-content="Jwellery Material" className="uppercase text-xl font-semibold tracking-wide ms-2 text-gray-600 ">
                <GiAbbotMeeple />
              </p>
              <span className="text-black text-sm tracking-wider  font-semibold"> : {product[0].jwelleryMaterial}</span>
            </p>
            <p className="my-3 flex">
              <Tooltip id="my-tooltip" />
              <p data-tooltip-id="my-tooltip" data-tooltip-content="Jwellery Color" className="uppercase text-xl font-semibold tracking-wide ms-2 text-gray-600 ">
                <IoColorWandOutline />
              </p>
              <span className="text-black text-sm tracking-wider  font-semibold"> : {product[0].jwelleryColour}</span>
            </p>

          </div>
        </div>
      </div>
    </div>
  );
};
